import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { firebaseAuth } from "src/hooks/use-firebase-app";

export const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_HOST_API,
    prepareHeaders: async(headers) => {
        const user = firebaseAuth.currentUser;

        if (user) {
            const accessToken = await user.getIdToken();
            headers.set('Authorization', `Bearer ${accessToken}`);
            console.log("Access Token: " + accessToken);
        }

        headers.set('Content-Type', 'application/json');

        return headers
    },
    timeout: 30000
});